require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./helix.dom.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.components.ui.js");
goog.provide('com.wsscode.blog.components.ui');

com.wsscode.blog.components.ui.loader_value = function com$wsscode$blog$components$ui$loader_value(x) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("com.wsscode.blog.components.ui", "loading", "com.wsscode.blog.components.ui/loading", -911961282), x)) {
    return null;
  } else {
    if (cljs.core.truth_(function () {
      try {
        var and__4115__auto__ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(x, new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017));

        if (cljs.core.truth_(and__4115__auto__)) {
          return null;
        } else {
          return and__4115__auto__;
        }
      } catch (e22465) {
        var _ = e22465;
        return null;
      }
    }())) {
      console.error(cljs.core.get.cljs$core$IFn$_invoke$arity$2(x, new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017)));
      return helix.core.get_react().createElement("div", null, "Error");
    } else {
      return x;
    }
  }
};

com.wsscode.blog.components.ui.loader = function com$wsscode$blog$components$ui$loader(x, f) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("com.wsscode.blog.components.ui", "loading", "com.wsscode.blog.components.ui/loading", -911961282), x)) {
    return helix.core.get_react().createElement("div", function () {
      var obj22467 = {
        "className": "loading-container"
      };
      return obj22467;
    }(), "Loading data...");
  } else {
    if (cljs.core.truth_(function () {
      try {
        return cljs.core.get.cljs$core$IFn$_invoke$arity$2(x, new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017));
      } catch (e22468) {
        var _ = e22468;
        return null;
      }
    }())) {
      console.error(cljs.core.get.cljs$core$IFn$_invoke$arity$2(x, new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017)));
      return helix.core.get_react().createElement("div", null, "Error");
    } else {
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(x) : f.call(null, x);
    }
  }
};

Object.defineProperty(module.exports, "loader_value", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.ui.loader_value;
  }
});
Object.defineProperty(module.exports, "loader", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.ui.loader;
  }
});